import styled from "styled-components";

const BackButtonStyled = styled.button`
	&.cta-link {
		color: ${props => props.theme.lightGreen};
		display: block;
		margin-top: 3rem;
		margin-bottom: 2rem;
		background-position: center;

		svg {
			margin-right: 1rem;
		}

		&:after {
			content: none;
		}
	}
`;

export default BackButtonStyled;